import StagePage from "src/stage/StagePage";
import { useWorkspace } from "../Workspace/context/WorkspaceContext";
import DocumentLibrary from "./DocumentLibrary";

export default function DocumentsPage() {
  const { currentWorkspaceId } = useWorkspace();
  return <StagePage className="crm-docs-page"><DocumentLibrary workspaceId={currentWorkspaceId} asPage /></StagePage>;
}
